<template>

  <div class="billing_sec">
    <div class="md-layout">
      <table-card>
        <template slot="header">
          <h4 class="title">Manage Team</h4>

          <md-button class="md-round" @click="showNewTeamModal()">
            <md-icon class="ml-5">person_add</md-icon>Add Team Member
          </md-button>
          <div class="pl-2">
            <md-field>  <md-select class="select-items-per-page" v-model="itemsPerPage" name="itemsPerPage">
                <md-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >{{ item }}</md-option>
          </md-select></md-field>
          
          </div>         
        </template>

        <template slot="content">
          <div class="info-wrap">
            <md-field class="md-field-search">
              <md-input @keyup.enter="searchInTableFields(false)" v-model="search" aria-label="search" placeholder="Search..." type="text">
              </md-input>
              <div class="hover" @click="searchInTableFields(false)">
                <md-icon>search</md-icon>
              </div>
              <div class="hover" @click="searchInTableFields(true)">
                <md-icon>replay</md-icon>
              </div>
            </md-field>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
              <md-table v-model="teamMembers" table-header-color="blue" v-if="!loading"
                class="billing-and-invoices-table">
                <md-table-row slot="md-table-row" slot-scope="{ item }"
                  :data-blanket-access-disabled="item.blanketAccessDisabled" :data-access="item.access">
                  <md-table-cell md-label="Date Created">{{
                    getFormattedDate(item.dateCreated)
                    }}</md-table-cell>
                  <md-table-cell md-label="Last Login">{{
                    getFormattedDate(item.lastLogin)
                    }}</md-table-cell>
                  <md-table-cell md-label="Team Member">{{
                    item.name
                    }}</md-table-cell>
                  <md-table-cell md-label="Email Address">{{
                    item.email
                    }}</md-table-cell>
                  <md-table-cell md-label="Credits">{{
                    item.limit
                    }}</md-table-cell>
                  <md-table-cell md-label="Credits Used"><a href="#">{{ item.products }}</a></md-table-cell>
                  <md-table-cell md-label="Manage">
                    <button type="button"
                      class="md-button md-raised md-danger table-action-button md-theme-default ml-5"
                      @click="showMemberModal(item.id, 'Disable')" v-if="!item.blanketAccessDisabled && item.access">
                      <div class="md-ripple">
                        <div class="md-button-content">
                          <md-icon>person_remove</md-icon>
                        </div>
                      </div>
                    </button>
                    <button type="button" class="md-button md-raised md-info table-action-button md-theme-default ml-5"
                      @click="showUpdateTeamModal(item)" v-if="!item.blanketAccessDisabled && item.access">
                      <div class="md-ripple">
                        <div class="md-button-content">
                          <md-icon>manage_accounts</md-icon>
                        </div>
                      </div>
                    </button>
                    <button v-if="(item.blanketAccessDisabled || !item.access)" type="button"
                      class="md-button md-raised md-success table-action-button md-theme-default ml-5"
                      @click="showMemberModal(item.id, 'Enable')">
                      <div class="md-ripple">
                        <div class="md-button-content">
                          <md-icon>person_add</md-icon>
                        </div>
                      </div>
                    </button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
              <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
                <div class="md-toolbar-row p-0">
                  <div class="md-toolbar-section-start">
                    <div class="pagin-page-info">
                      Showing page: {{ pagination.currentPage }} of
                      {{ pagination.total }}
                    </div>
                  </div>
                  <div class="md-toolbar-section-end">
                    <pagination class="pagination-no-border pagination-info" v-model="pagination.currentPage"
                      :per-page="pagination.perPage" :total="pagination.total" :page-count="pagination.total"
                      @changePage="onChangeMembersPage" @previousPage="onPreviousMembersPage"
                      @nextPage="onNextMembersPage">
                    </pagination>
                  </div>
                </div>
                <div class="md-toolbar-row p-0">
                  <div class="md-toolbar-section-start">
                    <div class="pagin-page-info">
                      Total of sub-accounts: {{ totalSubAccounts }}
                    </div>
                  </div>
                </div>
                <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 card-buttons">
                  <div class="button-container">
                    <md-button class="md-info md-round dark-blue-color" @click="downloadCSVData">EXPORT CSV<md-icon class="m-0">receipt_long
                      </md-icon>
                    </md-button>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="prospect_content">

            </div>
            <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 card-buttons">
              <div class="button-container">
                <md-button class="md-info md-round" @click="showNewTeamModal()"
                  >ADD TEAM MEMBER
                  <md-icon class="ml-5">person_add</md-icon>
                </md-button>
              </div>
            </div> -->

          </div>
        </template>
      </table-card>

    </div>

  </div>
</template>
<script>
import { Pagination, TableCard, Collapse } from '@/components';
import { mapGetters } from 'vuex';

export default {
  name: 'manage-team-tab',
  props: ['confirmation'],
  components: {
    Pagination,
    TableCard,

    // Collapse
  },
  data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50,100,250],
        total: 200,
      },
      itemsPerPage: 25,
      loading: false,
      tableData: [],
      teamMembers: [],
      search: null,
      type: null,
      id: null,
      totalSubAccounts: 0,
      csvData: [],
      csvTableData: [],
    };
  },
  async created() {
    await this.getSubscriptionsActivityTotals();
    await this.getSubscriptionsActivity();  
  },
  computed: {
    ...mapGetters(['updateTeamMemberDetails']),
  },
  watch: {
    itemsPerPage(){
      this.getSubscriptionsActivity();
    },
    confirmation() {
      if (this.confirmation)
        this.removeAddMember();
    },
    updateTeamMemberDetails() {
      let details = this.$store.getters['updateTeamMemberDetails'];

      if (!details.username) {
        this.getSubscriptionsActivity();
      }
    },
  },
  methods: {
    async downloadCSVData() {
      let csv = '';
      this.csvTableData = this.tableData;

      if (this.csvTableData.length) {
        let csvData = await this.getCsvData();

        csvData.forEach((row) => {
          csv += row.join(',');
          csv += '\n';
        });
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = 'Manage Team.csv';
        anchor.click();
      }
    },
    async getCsvData() {
      let csvData = [
        ['Date Created', 'Last Login', 'Team Member', 'Email Address', 'Credits', 'Credits Used'],
      ];
      this.csvTableData.forEach((e, i) => {
        csvData.push([e.dateCreated, e.lastLogin, e.name, e.email, e.limit, e.products]);
      });
      return csvData;
    },
    getFormattedDate(date) {
      if (date) {
        let newDate = new Date(date);
        let day = newDate.getDate().toString().padStart(2, '0');
        let month = (newDate.getMonth() + 1).toString().padStart(2, '0');
        let year = newDate.getFullYear().toString().substr(-2);
        return `${month}/${day}/${year}`;
      }
      return '';
    },
    searchInTableFields(isCleanUp) {

      if (isCleanUp)
        this.search = '';

      this.teamMembers = this.tableData.filter((item) => {
        if (this.conditionToFilterSearchTableFields(item))
          return item;
      });

    },
    conditionToFilterSearchTableFields(item) {
      if (item.name.includes(this.search)
        || item.email.includes(this.search)
        || item.firstName.includes(this.search)
        || item.lastName.includes(this.search)
        || item.dateCreated.includes(this.search)
        || item.lastLogin.includes(this.search)
        || item.products.toString().includes(this.search))
        return true;

      return false;
    },
    createDateString(date) {
      if (!date) {
        return '';
      }
      let tempDate = new Date(date.replace(/-/g, "/"));
      return `${tempDate.getMonth() +
        1}/${tempDate.getDate()}/${tempDate.getFullYear()}`;
    },
    showMemberModal(id, type) {
      this.$store.commit('SET_CONFIRMATION_MODAL', true);
      this.$store.commit('SET_CONFIRMATION_TYPE', type);
      this.id = id;
    },
    async removeAddMember() {

      let endpoint = this.$store.getters['confirmationType'] === 'Enable' ? 'team/reinstate' : 'team/remove';
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      this.tableData = this.tableData.filter((item) => item.id !== this.id);

      this.tableData = this.tableData.map((item) => {
        return {
          dateCreated: this.createDateString(item.created),
          email: item.email,
          id: item.id,
          lastLogin: this.createDateString(item.last_login),
          name: item.name,
          firstName: item.first_name,
          lastName: item.last_name,
          products: item.products,
          username: item.username,
          blanketAccessDisabled: item.blanket_access_disabled,
          access: item.access,
          limit: item.limit,
        };
      });
      this.teamMembers = this.tableData;

      let params =this.$store.getters['confirmationType'] === 'Enable' ? {
        session_id: currentSession,
        id: this.id,
      }: {
        session_id: currentSession,
        member_id: this.id,
      };

      await this.$store.dispatch(endpoint, params).then((res) => {
        this.$store.dispatch(
          'alerts/success',
          'Team member removed successfully!'
        );
        this.getSubscriptionsActivity();
      });
      this.$store.commit('SET_CONFIRMATION_MODAL', false);
    },
    async updateMember(item) {
      this.$store.commit('SET_SHOW_UPDATE_TEAM_MODAL', true);
      this.$store.commit('SET_UPDATE_TEAM_MEMBER_DETAILS', item);
    },
    async getSubscriptionsActivity() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      this.loading = true;
      let params = {
        session_id: currentSession,
        page: this.pagination.currentPage,
        itemsPerPage: this.itemsPerPage,
      };

      await this.$store.dispatch('team/list', params).then((res) => {
        this.loading = false;
        this.pagination.total = res.data.totalPages;
        this.totalSubAccounts = res.data.team.length;
        this.tableData = res.data.team;
        this.tableData = this.tableData.map((item) => {
          return {
            dateCreated: this.createDateString(item.created),
            email: item.email,
            id: item.id,
            lastLogin: this.createDateString(item.last_login),
            name: item.name,
            firstName: item.first_name,
            lastName: item.last_name,
            products: item.products,
            username: item.username,
            blanketAccessDisabled: item.blanket_access_disabled,
            access: item.access,
            limit: item.limit,
          };
        });

        this.teamMembers = this.tableData.sort((a, b) =>
          a.blanketAccessDisabled > b.blanketAccessDisabled ? 1 : -1
        );;
      });
    },
    async getSubscriptionsActivityTotals() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      this.loading = true;
      let params = {
        session_id: currentSession,
        page: 1,
        itemsPerPage:100,
      };

      await this.$store.dispatch('team/list', params).then((res) => {
        this.tableData = res.data.team;
        this.tableData = this.tableData.map((item) => {
          return {
            dateCreated: this.createDateString(item.created),
            email: item.email,
            id: item.id,
            lastLogin: this.createDateString(item.last_login),
            name: item.name,
            firstName: item.first_name,
            lastName: item.last_name,
            products: item.products,
            username: item.username,
            blanketAccessDisabled: item.blanket_access_disabled,
            access: item.access,
            limit: item.limit,
          };
        });
        this.$store.commit('user/SET_TOTAL_ACTIVE_TEAM_MEMBERS', this.tableData.filter(item => !item.blanketAccessDisabled).length);
        this.$store.commit('user/SET_TOTAL_TEAM_MEMBERS', this.tableData.length);
      });
    },
    showNewTeamModal() {
      this.$store.commit('SET_SHOW_NEW_TEAM_MODAL', true);
    },
    showUpdateTeamModal(item) {
      this.$store.commit('SET_SHOW_UPDATE_TEAM_MODAL', true);
      this.$store.commit('SET_UPDATE_TEAM_MEMBER_DETAILS', item);
    },
    onChangeMembersPage(val) {
      this.pagination.currentPage = val;
      this.getSubscriptionsActivity();
    },
    onPreviousMembersPage(val) {
      this.pagination.currentPage = val;
      this.getSubscriptionsActivity();
    },
    onNextMembersPage(val) {
      this.pagination.currentPage = val;
      this.getSubscriptionsActivity();
    }
  },
};
</script>
<style lang="scss" scoped>
.md-button {
  height: 40px;
  margin-left: auto;
  align-self: center;
  font-size: 14px;
  line-height: 20px;

  .md-ripple {
    padding: 10px 20px;
  }
}

tr[data-blanket-access-disabled="1"] {
  background-color: #b8c3d0;
}

tr[data-access="0"] {
  background-color: #b8c3d0;
}

.md-field-search {
  background-color: white;
  border-radius: 20px;
  /* padding-left: 50px; */
  //margin-left: 100px;
  color: white !important;
}
.select-items-per-page{
  background-color: #fff;
  border-radius: 8px;
  padding-left: 10px;
}
</style>
